import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
export default {
  props: ['siteId'],
  data: function data() {
    return {
      videoSrcArr: [],
      width: 0,
      height: 0
    };
  },
  mounted: function mounted() {
    this.width = document.querySelector('.video-box').clientWidth * 0.47;
    this.height = document.querySelector('.video-box').clientWidth * 0.25;
    window.addEventListener('resize', this.getResize); // this.getVideoList()
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.getResize);
  },
  // watch: {
  //   siteId(value) {
  //     this.getVideoList()
  //   }
  // },
  methods: {
    getResize: function getResize() {
      this.width = document.querySelector('.video-box').clientWidth * 0.47;
      this.height = document.querySelector('.video-box').clientWidth * 0.25;
    },
    getVideoList: function getVideoList() {
      var _this = this;

      this.videoSrcArr = [];
      getAction('site/info/devops/getBySite', {
        siteId: this.siteId
      }).then(function (res) {
        if (res.success) {
          getAction("sys/common/file/queryFile/site_info_devops/".concat(res.result.id)).then(function (res) {
            if (res.success) {
              res.result.forEach(function (item) {
                _this.videoSrcArr.push(window._CONFIG['domianURL'] + '/sys/common/file/view/' + item.id);
              });
            }
          });
        }
      });
    }
  }
};